<template>
<div>
    <div v-if="ie=='i'">
        <!-- 布基纳法索(BFA)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商ID</th>
                        <td width="25%">{{billInfo.ImporterId}}</td>
                        <th width="25%">进口商原始</th>
                        <td width="25%">{{billInfo.ImporterOriginal}}</td>
                    </tr>
                    <tr>
                        <th>净重</th>
                        <td>{{billInfo.NetWeight}} {{billInfo.NetWeightUnit}}</td>
                        <th>美元金额</th>
                        <td>{{billInfo.Value}} {{billInfo.ValueUnit}}</td>
                    </tr>
                    <tr>
                        <th>CIF当地金额</th>
                        <td colspan="3">{{billInfo.CifValue}} {{billInfo.CifValueUnit}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">原产国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.DestinationCountry}}</td>
                    </tr>
                    <tr>
                        <th>港口</th>
                        <td>{{billInfo.PortOfDischarge}}</td>
                        <th>贸易方式标识</th>
                        <td>{{billInfo.RegimeCode}}</td>
                    </tr>
                    <tr>
                        <th>贸易方式</th>
                        <td>{{billInfo.RegimeDescription}}</td>
                        <th>贸易方式说明</th>
                        <td>{{billInfo.RegimeLabel}}</td>
                    </tr>
                    <tr>
                        <th>关税</th>
                        <td colspan="3">{{billInfo.CustomsDutyPaid}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 布基纳法索(BFA)出口提单明细 -->
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>